export const dispatchCustomEvent = (
  eventName: string,
  eventData?: object | string | undefined,
) => {
  const event = new CustomEvent(eventName, { detail: eventData });
  document.dispatchEvent(event);
};
